module.exports = __webpack_public_path__ + "img/grust.0478b00.gif?v=1764903765445";